/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { TabContext, TabList } from '@mui/lab';
import { Button, TextField, Box, Switch, FormControlLabel, FormControl, FormLabel, RadioGroup, Radio, Typography, Tooltip, IconButton, Tab } from "@mui/material";
import { Col, Row, Image } from "antd";
import { useParams } from "react-router-dom";
import crudActions from "../../../../CRUD/redux/actions";
import addressActions from "../../../../Admin/Address/redux/actions";
import groupActions from "../../../Setup/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import SalesPrice from "../../../../Product/Setup/components/Price/SalesPrice";
import SalesDiscount from "../../../../Product/Setup/components/Price/SalesDiscount";
import { toast } from 'react-toastify';
import productActions from "../../../../Product/Product/redux/actions";
import { customerTypeList, classificationList, SalesPriceHeadCustomer, SalesDiscountHeadCustomer } from "../../../../../config/constant";
import actions from "../../redux/actions";
import globalAddressActions from "../../../../Admin/Home/redux/actions";
import {
    emptyValidation, customEmailOptionalValidation, customAlaphaNumericValidation, customAlaphaNumericValidationOptional
} from "../../../../../helpers/validation";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkCRUDViewPermission, checkCRUDPermission, capitalizeFirstLetter, scrollToError, idNamingConversion } from "../../../../../helpers/utilities";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import younoteAdminSetupActions from "../../../../YounoteAdmin/Setup/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";

const CustomerEdit = (props) => {
    const { areaDetails, languageDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const { partyGstdetails, currencyDetails, mopDetails, taxCodedetails, cashDiscountDetails, otherTaxesdetails } = useSelector(state => state.adminSetupReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const { getTeamData } = useSelector(state => state.homeReducer);
    const { readDetails, readLoader, readError, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const { history } = props;
    let { customerId } = useParams();
    const decryptedId = AESDecrypt(customerId);
    const [businessType, setBusinessType] = useState('');
    const [name, setName] = useState('');
    const [isHold, setIsHold] = useState(false);
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [classification, setClassification] = useState('');
    const [languageId, setLanguageId] = useState('');
    const [groupId, setGroupId] = useState('');
    const [salesRepId, setSalesRepId] = useState('');
    const [gstCodeId, setGstCodeId] = useState('');
    const [gstin, setGstin] = useState('');
    const [address1, setAddress1] = useState('');
    const [customerBusinessId, setCustomerBusinessId] = useState('');
    const [priceIncludesTax, setPriceIncludesTax] = useState(false);
    const [areaId, setAreaId] = useState('');
    const [pincodeId, setPincodeId] = useState('');
    const [stateId, setStateId] = useState('');
    const [cityId, setCityId] = useState('');
    const [countryId, setCountryId] = useState('');
    const { roleManagement } = useSelector(state => state.authReducer);
    const [identityType, setIdentityType] = useState('');
    const [pan, setPan] = useState('');
    const prevReadDetails = usePrevious(readDetails);
    const [showDetails, setShowDetails] = useState(true);
    const [taxCodeId, setTaxCodeId] = useState('');
    const [tcs, setTcs] = useState(false);
    const [tcsId, setTcsId] = useState('');
    const [tdsId] = useState('');
    const [tds, setTds] = useState(false);
    const [cashDiscountId, setCashDiscountId] = useState('');
    const [contactName, setContactName] = useState('');
    const [tradingName, setTradingName] = useState('');
    const [alternateMobile, setAlternateMobile] = useState('');
    const [mopId, setMopId] = useState('');
    const [currencyId, setCurrencyId] = useState('');
    const [inAppStatus, setInAppStatus] = useState('');
    const [inAppTransition, setInAppTransition] = useState(false);
    const { taxType } = useSelector(state => state.younoteAdminSetupReducer);

    const [errorBusinessType, setErroBusinessType] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [commonError, setCommonError] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorTcs, setErrorTcs] = useState(false);
    const [errorGstType, setErrorGstType] = useState(false);
    const [errorGstIn, setErrorGstIn] = useState(false);
    const [errorGstCode, setErrorGstCode] = useState(false);
    const [errorPincode, setErrorPincode] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [errorLanguage, setErrorLanguage] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    //const [errorClassification, setErrorClassification] = useState(false);
    const [errorContactForm, setErrorContactForm] = useState(false);
    const [erroremptyAlternateName, setErroremptyAlternateName] = useState(false);
    // const [erroremptyAlternateNumber, setErroremptyAlternateNumber] = useState(false);

    const childRef = useRef('');
    const priceRef = useRef('');
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [factBox, setFactBox] = useState([]);
    const [gstTypeList, setGstTypeList] = useState([]);
    const [taxTypeId, setTaxTypeId] = useState('');

    const [value, setValue] = useState('sales-price');
    const [apiUrl, setApiUrl] = useState('salesPriceAgreement');
    const [heads, setHeads] = useState(SalesPriceHeadCustomer);

    const menus = [
        {
            "name": "Create Order",
            "link": ""
        },
        {
            "name": "Create Sales Bill",
            "link": `/sales/sales-management/self-bill/${AESEncrypt(decryptedId)}/create`
        },
        {
            "name": "Collect Payment",
            "link": `/sales/sales-management/customer-payment/${AESEncrypt(decryptedId)}/create`
        },
        {
            "name": "Invoice History",
            "link": `/sales/transactions/${AESEncrypt(decryptedId)}/invoice-history`
        },
        {
            "name": "Order History",
            "link": ""
        },
        {
            "name": "Settlement",
            "link": `/sales/report-and-enquiry/${AESEncrypt(decryptedId)}/customer-settlement`
        },
        {
            "name": "Transaction History",
            "link": `/sales/transactions/${AESEncrypt(decryptedId)}/customer-transaction`
        }
    ];


    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('All Customers', 'edit', history, 'Sales')) {
            loadTasks();
        }
        return () => {
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
            dispatch({ type: actions.CLEAR_MANAGEMENT_DETAILS_START });
        }
    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            handleSubmit(e);
        } else if (e.altKey && e.keyCode === 66) {
            e.preventDefault();
            history.push(`/sales/sales-management/self-bill/${AESEncrypt(decryptedId)}/create`);
        } else if (e.altKey && e.keyCode === 84) {
            e.preventDefault();
            history.push(`/sales/transactions/${AESEncrypt(decryptedId)}/customer-transaction`);
        } else if (e.altKey && e.keyCode === 73) {
            e.preventDefault();
            history.push(`/sales/transactions/${AESEncrypt(decryptedId)}/invoice-history`);
        } else if (e.altKey && e.keyCode === 80) {
            e.preventDefault();
            history.push(`/sales/sales-management/customer-payment/${AESEncrypt(decryptedId)}/create`);
        } else if (e.altKey && e.keyCode === 77) {
            e.preventDefault();
            history.push(`/sales/report-and-enquiry/${AESEncrypt(decryptedId)}/customer-settlement`);
        }
    };
    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if (countryId !== '') {
            setGstTypeList(taxType);
            if (taxTypeId === '' && taxType && taxType?.length > 0) {
                let a = taxType && taxType?.filter((el) => el.isDefault);
                if (a && a.length > 0) {
                    setTaxTypeId(a[0]?.id);
                }
            }
        }
    }, [countryId, taxType]);

    const loadTasks = useCallback(() => {
        if (customerId === undefined || decryptedId === 0) {
            history.push("/sales/sales-management/all-customers");
            return true;
        }

        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: globalAddressActions.TEAM_DETAILS_START, url: 'team', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.TAXCODE_DETAILS_START, url: 'taxcode', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.CASHDISCOUNT_DETAILS_START, url: 'cashdiscount', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.OTHERTAXES_DETAILS_START, url: 'othertaxes', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: addressActions.LANGUAGE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
                where: { "and": [{ status: 'ACTIVE' }] },
                order: 'id  desc'
            }
        });
        dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "customerProfile" });
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 'sales-price') {
            setApiUrl('salesPriceAgreement');
            setHeads(SalesPriceHeadCustomer);
        } else {
            setApiUrl('sales-discounts');
            setHeads(SalesDiscountHeadCustomer);
        }
    };


    const handleChangeCountry = (value) => {
        setCountryId(value);
        setStateId('');
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = countryDetails && countryDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCurrencyId(a[0].currencyId);
        }
        dispatch({
            type: younoteAdminSetupActions.TAX_TYPE_START,
            url: `/tax-types/byCountry/${value}`,
            // filter: {
            //     where: { countryTaxId: 1 }
            // }
        });
    }

    const emptyState = () => {
        setErroBusinessType(false);
        setErrorName(false);
        setCommonError(false);
        setErrorMobile(false);
        setErrorEmail(false);
        setErrorGstType(false);
        setErrorLanguage(false);
        setErrorCurrency(false);
        setErrorGstCode(false);
        setErrorContactForm(false);
        setErroremptyAlternateName(false);
        //setErroremptyAlternateNumber(false);
        setErrorGstIn(false);
        setErrorPincode(false);
        setErrorState(false);
        setErrorTcs(false);
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        childRef?.current?.handleAdjustHeight();
        let emptyGstIn = {};
        let emptyBusinessType = emptyValidation('Business Type', businessType, 'dropDown');
        let emptyName = emptyValidation('Name', name);
        let emptyEmail = customEmailOptionalValidation('Email', email);
        let emptyMobile = emptyValidation('Mobile Number', mobile);
        let emptyTaxTypeId = emptyValidation('Gst Type', taxTypeId, 'dropDown');
        let emptyLanguage = emptyValidation('Language', languageId, 'dropDown');
        let emptyCurrency = emptyValidation('Currency', currencyId, 'dropDown');
        // let emptyContactName = customAlaphabetValidationOptional('Contact Name', contactName)
        // let emptyAlternateName = customAlaphabetValidationOptional('Alternate Name', tradingName)
        // let emptyClassification = emptyValidation('Classification', classification);
        //let emptyalternateMobile = customPhoneValidationOptional('Alternate Phone', alternateMobile);

        let emptyGstCode = { isValid: true };
        if (taxTypeId !== '') {
            let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            if (a && a.length > 0 && (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS')) {
                emptyGstIn = customAlaphaNumericValidationOptional('GST IN', gstin, 15);
            } else {
                emptyGstIn = customAlaphaNumericValidation('GST IN', gstin, 15);
            }

            if (a && a.length > 0) {
                if (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS') {
                    emptyGstCode = { isValid: true }
                } else {
                    emptyGstCode = emptyValidation('Gst Code', gstCodeId, 'dropDown');
                }
            }
        }


        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptyStateVal = emptyValidation('State', stateId, 'dropDown');

        let emptyTcs = { isValid: true };

        if (tcs) {
            emptyTcs = emptyValidation('TCS', tcsId, 'dropDown');
        }

        emptyState();
        if (emptyBusinessType.isValid && emptyName.isValid && emptyEmail.isValid && emptyMobile.isValid && emptyTaxTypeId.isValid
            && emptyLanguage.isValid && emptyCurrency.isValid && emptyTcs.isValid
            && emptyGstIn.isValid && emptyGstCode.isValid && emptyPincode.isValid && emptyStateVal.isValid) {
            let details = {
                ...readDetails,
                type: businessType,
                name: name,
                email: email || '',
                mobile: mobile,
                isHold: isHold,
                //classification: classification,
                languageId: languageId,
                taxTypeId: taxTypeId,
                gstin: gstin || '',
                address1: address1 || '',
                contactName: contactName,
                tradingName: tradingName,
                alternateMobile: alternateMobile || '',
                currencyId: currencyId,
                countryId: countryId,
                priceIncludesTax: priceIncludesTax || false,
                taxCodeId: taxCodeId || 0,
                tcsId: tcsId || 0,
                tdsId: tdsId || 0,
                tcsBoolean: tcs || false,
                tdsBoolean: tds || false,
                cashDiscountId: cashDiscountId || 0
            }
            if (pan) {
                let ideType = identityType || 'PAN';
                details["pan"] = ideType + '-' + pan;
            } else {
                details["pan"] = '';
            }
            delete details.taxType;
            delete details.city;
            delete details.state;
            delete details.country;
            delete details.currency;
            delete details.language;
            delete details.pincode;
            delete details.partyGst;
            delete details.facts; delete details.cashDiscount; delete details.tcs;
            delete details.business; delete details.taxCode; delete details.tcsCode;
            delete details.customerBalance; delete details.customerBusiness;
            delete details.mop; delete details.area; delete details.group; delete details.salesRep;

            if (groupId) {
                details["groupId"] = groupId;
            } else {
                details["groupId"] = 0;
            }

            if (salesRepId) {
                details["salesRepId"] = salesRepId;
            } else {
                details["salesRepId"] = 0;
            }

            if (gstCodeId) {
                details["partyGstId"] = gstCodeId;
            } else {
                details["partyGstId"] = 0;
            }

            if (mopId) {
                details["mopId"] = mopId;
            } else {
                details["mopId"] = 0;
            }

            if (areaId) {
                details["areaId"] = areaId;
            } else {
                details["areaId"] = 0;
            }
            if (pincodeId) {
                details["pincodeId"] = pincodeId;
            } else {
                details["pincodeId"] = 0;
            }
            if (stateId) {
                details["stateId"] = stateId;
            } else {
                details["stateId"] = 0;
            }
            if (cityId) {
                details["cityId"] = cityId;
            } else {
                details["cityId"] = 0;
            }

            if (inAppStatus) {
                details["inAppStatus"] = inAppStatus;
            } else {
                // details["inAppStatus"] = 'REQUEST SENT';
            }

            if (customerBusinessId) {
                details["customerBusinessId"] = customerBusinessId;
            } else {
                details["customerBusinessId"] = 0;
            }

            if (classification) {
                details["classification"] = classification;
            } else {
                details["classification"] = '';
            }

            details["inAppTransition"] = inAppTransition;
            // let data = Object.fromEntries(Object.entries(details).filter(([_, v]) => v !== null));          
            if (details["inAppStatus"] === null) {
                delete details["inAppStatus"];
            }
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                id: decryptedId,
                url: "customerProfile",
                title: "Customer Profile",
                details: details,
                method: 'put'
            })
        } else {
            if (emptyBusinessType.errors) {
                setErroBusinessType(emptyBusinessType.errors);
            }
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }
            if (emptyTcs.errors) {
                setErrorTcs(emptyTcs.errors);
            }
            if (emptyStateVal.errors) {
                setErrorState(emptyStateVal.errors);
            }
            if (emptyMobile.errors) {
                setErrorMobile(emptyMobile.errors);
            }
            if (emptyEmail.errors) {
                setErrorEmail(emptyEmail.errors);
            }

            if (emptyLanguage.errors) {
                setErrorLanguage(emptyLanguage.errors);
            }
            if (emptyCurrency.errors) {
                setErrorCurrency(emptyCurrency.errors);
            }
            if (emptyTaxTypeId.errors) {
                setErrorGstType(emptyTaxTypeId.errors);
                setErrorGstCode(emptyGstCode.errors);
            }

            // if (taxTypeId !== '') {
            //     let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            //     if (a && a.length > 0 && a[0].taxCode !== 'UNRB' && emptyGstCode.errors) {
            //         setErrorGstCode(emptyGstCode.errors);
            //     }
            // }
            if (emptyGstCode.errors) {
                setErrorGstCode(emptyGstCode.errors);
            }
            // if (emptyClassification.errors) {
            //     setErrorClassification(emptyClassification.errors);
            // }
            // if (emptyContactName.errors) {
            //     setErrorContactForm(emptyContactName.errors);
            // }
            // if (emptyAlternateName.errors) {
            //     setErroremptyAlternateName(emptyAlternateName.errors);
            // }
            // if (emptyalternateMobile.errors) {
            //     setErroremptyAlternateNumber(emptyalternateMobile.errors);
            // }
            if (emptyGstIn.errors) {
                setErrorGstIn(emptyGstIn.errors);
            }
            scrollToError();
        }
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            //toast(editDetails);
            if (roleManagement !== '' && checkCRUDPermission('All Customers', 'view', 'Sales')) {
                history.push(`/sales/sales-management/all-customers/${AESEncrypt(decryptedId)}/view`, 'edit');
            } else {
                history.push(`/sales/sales-management/all-customers`);
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            toast.dismiss();
            toast.error(error);
        }
    }, [editDetails, editError]);

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            if (readDetails.stateId) {
                changeStateApi(readDetails.stateId);
            }

            if (readDetails.pincodeId) {
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { ["and"]: [{ pincodeId: readDetails.pincodeId }] }
                    }
                });
            }
            // let panArray = [];
            // if (readDetails?.pan) {
            //     panArray = readDetails?.pan.split("-");
            // }

            let identityType = '';
            let pan = '';

            if (readDetails?.pan) {
                const panArray = readDetails.pan.split('-').map(v => v.trim());

                identityType = panArray[0] || '';
                pan = panArray.slice(1).join('-') || '';
            }

            setBusinessType(readDetails?.type || '');
            setName(readDetails?.name || '');
            setIsHold(readDetails?.isHold || false);
            setPriceIncludesTax(readDetails?.priceIncludesTax || false);
            setMobile(readDetails?.mobile || '');
            setEmail(readDetails?.email || '');
            setAddress1(readDetails?.address1 || '');
            setClassification(readDetails.classification);
            setLanguageId(readDetails.languageId);
            setGroupId(readDetails.groupId);
            setSalesRepId(readDetails?.salesRepId || 0);
            setTaxTypeId(readDetails.taxTypeId);
            setGstCodeId(readDetails.partyGstId > 0 ? readDetails.partyGstId : '');
            setIdentityType(identityType);
            setPan(pan);
            setGstin(readDetails?.gstin || '');
            setAreaId(readDetails?.areaId);
            setPincodeId(readDetails?.pincodeId);
            setCityId(readDetails?.cityId);
            setStateId(readDetails?.stateId);
            setCountryId(readDetails?.countryId);
            setCashDiscountId(readDetails?.cashDiscountId || '');
            setContactName(readDetails?.contactName || '');
            setTradingName(readDetails?.tradingName || '');
            setAlternateMobile(readDetails?.alternateMobile || '');
            setMopId(readDetails.mopId > 0 ? readDetails.mopId : '');
            setCurrencyId(readDetails.currencyId);
            setInAppStatus(readDetails.inAppStatus);
            setCustomerBusinessId(readDetails.customerBusinessId);
            setInAppTransition(readDetails?.inAppTransition || false);
            setTaxCodeId(readDetails?.taxCodeId || '');
            setTcsId(readDetails?.tcsId || '');
            setTcs(readDetails?.tcsBoolean || false);
            setTds(readDetails?.tdsBoolean || false);
            dispatch({
                type: younoteAdminSetupActions.TAX_TYPE_START,
                url: `/tax-types/byCountry/${readDetails.countryId}`,
                // filter: {
                //     where: { countryTaxId: 1 }
                // }
            });

            if (readDetails?.isHold) {
                menus.splice(0, 3);
            }
            if (readDetails?.facts) {
                setFactBox(readDetails.facts);
                if (readDetails?.isNew) {
                    let iH = menus.findIndex((d, i) => d.name === 'Invoice History');
                    menus[iH]['disabled'] = true;
                    let oH = menus.findIndex((d, i) => d.name === 'Order History');
                    menus[oH]['disabled'] = true;
                    let s = menus.findIndex((d, i) => d.name === 'Settlement');
                    menus[s]['disabled'] = true;
                    let tH = menus.findIndex((d, i) => d.name === 'Transaction History');
                    menus[tH]['disabled'] = true;
                }
                setTimeout(function () {
                    dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, factBox: readDetails.facts, component: "All Customers" });
                    childRef?.current?.handleAdjustHeight();
                }, 200)
            }
            setShowDetails(false);
        } else if (readError) {
            if (readError.error.statusCode) {
                toast.error('Customer ID is invalid');
                history.push('/sales/sales-management/all-customers');
            }
        }
    }, [readDetails, readError]);

    const changeArea = (value) => {
        setAreaId(value);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const changePincode = (value) => {
        setPincodeId(value);
        setAreaId('');
        let a = pincodeDetails && pincodeDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: value }] }
                }
            });
        }
        return [];
    }


    const changeCity = (value) => {
        setCityId(value);
        setAreaId('');
        setPincodeId('');
    }

    const changeState = (value) => {
        setStateId(value);
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = stateDetails && stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
            setCurrencyId(a[0].country && a[0].country.currencyId);
            dispatch({
                type: younoteAdminSetupActions.TAX_TYPE_START,
                url: `/tax-types/byCountry/${a[0].countryId}`,
                // filter: {
                //     where: { countryTaxId: 1 }
                // }
            });
        }
        changeStateApi(value);
    }

    const handleChangeTransaction = (trans, details) => {
        setInAppTransition(trans);
        if (details?.inAppStatus === 'ACCEPTED') {
            if (!trans) {
                setInAppStatus('STOPPED');
            } else {
                setInAppStatus(details?.inAppStatus);
            }
        }

        if (details?.inAppStatus === 'NO' || details?.inAppStatus === 'REJECTED' || details?.inAppStatus === 'STOPPED') {
            if (trans) {
                setInAppStatus('REQUEST SENT');
            } else {
                setInAppStatus(details?.inAppStatus);
            }
        }
    }

    const handlePartyGstDetails = () => {
        let result = partyGstdetails;
        if (taxTypeId !== '' && taxType && taxType.length > 0) {
            let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            if (a && a.length > 0 && a[0]?.taxCode === 'SPEZ') {
                result = partyGstdetails.filter((el) => { return el.isSEZ })
            }
        }
        return result;
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                cls={'newImg'}
                img={SalesIcon}
                title={'Sales'}
                closeLink={'/sales/sales-management/all-customers'}
                links={[{ 'label': 'Sales', 'link': '/sales' },
                { 'label': 'All Customers', 'link': '/sales/sales-management/all-customers' }, { 'label': 'Customer Details', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Edit Customer'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        ref={childRef}
                        index={0}
                        component={
                            <>
                                {
                                    showDetails === false && readDetails &&
                                    <Box
                                        className={clsx(classes.removeUnderline)}
                                        component="form"
                                        autoComplete="off"

                                        onSubmit={(e) => handleSubmit(e)}>
                                        <Row>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignCenter}>
                                                {
                                                    commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError)} />
                                                }
                                            </Col>
                                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                            </Col>
                                            <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} className={classes.textAlignRight}>
                                                <Button
                                                    tabIndex={-1}
                                                    type='submit'
                                                    color='primary'
                                                    variant="contained"
                                                    id={idNamingConversion('Submit', 'customerProfile', 'Button')}
                                                    className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>
                                                    Update
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row gutter={50}>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Business Type ", <span key="Business Type" className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                    details={customerTypeList}
                                                    parentValue={customObject(customerTypeList, businessType)}
                                                    onChange={(data) => setBusinessType(data.id)}
                                                    position={"bottom"}
                                                    id={idNamingConversion('Business Type', 'customerProfile', 'DropDown')}
                                                    customClasses={classes.margin20t}
                                                    parentError={errorBusinessType}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer ID</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.serialNo ? readDetails?.serialNo : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label={["Customer Name ", <span key="Customer Name" className={classes.colorRedRequired}> *</span>]}
                                                    fullWidth
                                                    className={classes.margin20t}
                                                    error={errorName && true}
                                                    helperText={errorName}
                                                    value={name}
                                                    id={idNamingConversion('Customer Name', 'customerProfile', 'TextField')}
                                                    variant={'standard'}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom
                                                    }}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Row>
                                                    <Col span={10}>
                                                        <FormControlLabel
                                                            classes={{
                                                                label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                            }}
                                                            id={idNamingConversion('Hold', 'customerProfile', 'Radio')}
                                                            control={<Switch size='small'
                                                                className={clsx(classes.customSwitch)}
                                                                onChange={(e) => setIsHold(!isHold)}
                                                                checked={isHold}
                                                            />}
                                                            label="Hold"
                                                            labelPlacement="top"
                                                            className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                        />
                                                    </Col>
                                                    <Col span={10} offset={4} >
                                                        <FormControlLabel
                                                            classes={{
                                                                label: clsx(classes.fonSize13, classes.textAlignRight, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                            }}
                                                            id={idNamingConversion('Price Include Tax', 'customerProfile', 'Radio')}
                                                            control={<Switch size='small'
                                                                className={clsx(classes.customSwitch)}
                                                                onChange={(e) => setPriceIncludesTax(!priceIncludesTax)}
                                                                checked={priceIncludesTax}
                                                            />}
                                                            label="Price Inc. Tax"
                                                            labelPlacement="top"
                                                            className={clsx(classes.marginLeft0, classes.margin20t)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Sales Rep Id "]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE')}
                                                    parentValue={customObject(getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE'), salesRepId)}
                                                    onChange={(data) => setSalesRepId(data.id)}
                                                    id={idNamingConversion('Sales Rep Id', 'customerProfile', 'DropDown')}
                                                    onChangeText={(value) => {
                                                        if (value === '') {
                                                            setSalesRepId('')
                                                        }
                                                    }}
                                                    position={"bottom"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label={["Mobile Number ", <span key="Mobile Number" className={classes.colorRedRequired}> *</span>]}
                                                    fullWidth
                                                    // type='number'
                                                    id={idNamingConversion('Mobile Number', 'customerProfile', 'TextField')}
                                                    error={errorMobile && true}
                                                    helperText={errorMobile}
                                                    value={mobile}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom
                                                    }}
                                                    //onKeyDown={(e) => handleKeyDown(e)}
                                                    onChange={(e) => setMobile(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='Email'
                                                    fullWidth
                                                    value={email}
                                                    error={errorEmail && true}
                                                    helperText={errorEmail}
                                                    variant={'standard'}
                                                    id={idNamingConversion('Email', 'customerProfile', 'TextField')}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Classification "]}
                                                    heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                    details={classificationList}
                                                    parentValue={customObject(classificationList, classification)}
                                                    onChange={(data) => setClassification(data.id)}
                                                    id={idNamingConversion('Classification', 'customerProfile', 'DropDown')}
                                                    position={"bottom"}
                                                    //parentError={errorClassification}
                                                    customClasses={classes.margin20t}
                                                    onChangeText={(value) => {
                                                        if (value === '') {
                                                            setClassification('')
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Preferred Language ", <span key="Preferred Language" className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={languageDetails}
                                                    id={idNamingConversion('Preferred Language', 'customerProfile', 'DropDown')}
                                                    parentValue={customObject(languageDetails, languageId)}
                                                    onChange={(data) => setLanguageId(data.id)}
                                                    position={"bottom"}
                                                    parentError={errorLanguage}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Group "]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={customerGroupdetails}
                                                    parentValue={customObject(customerGroupdetails, groupId)}
                                                    id={idNamingConversion('Group', 'customerProfile', 'DropDown')}
                                                    onChange={(data) => setGroupId(data.id)}
                                                    onChangeText={(value) => {
                                                        if (value === '') {
                                                            setGroupId('')
                                                        }
                                                    }}
                                                    position={"bottom"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["GST Type "]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                                    { 'key': 'taxCode', 'name': 'Code' }]}
                                                    details={gstTypeList}
                                                    parentValue={customObject(gstTypeList, taxTypeId)}
                                                    id={idNamingConversion('GST Type', 'customerProfile', 'DropDown')}
                                                    onChange={(data) => {
                                                        setTaxTypeId(data.id);
                                                        setGstCodeId(data?.partyGstId || '');
                                                    }}
                                                    parentError={errorGstType}
                                                    position={"bottom"}
                                                    customClasses={clsx(classes.margin20t, classes.dropDownPointer)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Party GST Code "]}
                                                    heads={[{ 'key': 'code', 'name': 'Party GST Code' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    id={idNamingConversion('Party GST Code', 'customerProfile', 'DropDown')}
                                                    details={handlePartyGstDetails()}
                                                    parentValue={customObject(handlePartyGstDetails(), gstCodeId)}
                                                    onChange={(data) => setGstCodeId(data.id)}
                                                    parentError={errorGstCode}
                                                    position={"bottom"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='GST Number (GSTIN)'
                                                    fullWidth
                                                    error={errorGstIn && true}
                                                    helperText={errorGstIn}
                                                    value={gstin}
                                                    variant={'standard'}
                                                    id={idNamingConversion('GST Number', 'customerProfile', 'TextField')}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setGstin(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <FormControl
                                                    tabIndex={-1}
                                                    className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton, classes.customIdentityRadioButton)}
                                                    variant={'standard'}
                                                    fullWidth>
                                                    <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Identity Type</FormLabel>
                                                    <RadioGroup row
                                                        defaultValue={"PAN"}
                                                        aria-labelledby="demo-customized-radios"
                                                        name="identityType"
                                                        value={identityType || "PAN"}
                                                        onChange={(e) => setIdentityType(e.target.value)}>
                                                        <FormControlLabel value={"PAN"} control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="PAN" />
                                                        <FormControlLabel value={"TAN"} control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="TAN" />
                                                        <FormControlLabel value={"CIN"} control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="CIN" />
                                                        <FormControlLabel value={'LIC'} control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="License Number" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label={`${identityType || "PAN"} Number`}
                                                    fullWidth
                                                    id={idNamingConversion("PAN Number", 'customerProfile', 'TextField')}
                                                    value={pan}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setPan(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeaderToolTip, classes.typographyHeader, classes.bold)}>

                                                    <span>Address</span>
                                                    <Tooltip
                                                        classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidth) }}
                                                        title={'Billing Address'} arrow placement="top" className={classes.tooltip}>
                                                        <IconButton>
                                                            <Image src={infoMarkIcon} preview={false} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["State/Province ", <span key={"State/Province"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'State Name' },
                                                    { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                                    details={stateDetails}
                                                    parentValue={customObject(stateDetails, stateId)}
                                                    onChange={(data) => changeState(data.id)}
                                                    position={"top"}
                                                    id={idNamingConversion('State', 'customerProfile', 'DropDown')}
                                                    customClasses={classes.margin20t}
                                                    parentError={errorState}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'code', 'name': 'Pincode' },
                                                    { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                                    details={pincodeDetails}
                                                    parentValue={customObject(pincodeDetails, pincodeId)}
                                                    onChange={(data) => changePincode(data.id)}
                                                    position={"top"}
                                                    id={idNamingConversion('Pincode', 'customerProfile', 'DropDown')}
                                                    customClasses={classes.margin20t}
                                                    parentError={errorPincode}
                                                />
                                            </Col>
                                            <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}></Col>
                                            <Col xxl={10} xl={10} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50}>
                                                    <Col xxl={12} xl={12} lg={6} md={8} sm={12} xs={24}>
                                                        <TextField autoComplete='one-time-code'
                                                            label=''
                                                            value={address1}
                                                            placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                            variant={'outlined'}
                                                            className={clsx(classes.margin20t, classes.customDescription)}
                                                            fullWidth
                                                            multiline
                                                            id={idNamingConversion('address', 'customerProfile', 'TextField')}
                                                            name={"address"}
                                                            rows={6}
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                },
                                                                style: { height: 170 },
                                                            }}
                                                            InputLabelProps={{
                                                                className: classes.textFieldLableColor,
                                                            }}
                                                            onChange={(e) => setAddress1(e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={12} xl={12} lg={6} md={8} sm={12} xs={24}>
                                                        <AutoCompleteComponent
                                                            name={["Area"]}
                                                            heads={[{ 'key': 'name', 'name': 'Area Name' },
                                                            { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                                            { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                                            { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                                            details={areaDetails}
                                                            id={idNamingConversion('Area', 'customerProfile', 'DropDown')}
                                                            parentValue={customObject(areaDetails, areaId)}
                                                            onChange={(data) => { changeArea(data.id) }}
                                                            position={"top"}
                                                            customClasses={classes.margin20t}
                                                            customLink={'/admin/address/area'}
                                                            linkText={'Go to Area'}
                                                            infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                                        />
                                                        <AutoCompleteComponent
                                                            name={["Dist/City/Town"]}
                                                            heads={[{ 'key': 'name', 'name': 'Name' },
                                                            { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                                            details={cityDetails}
                                                            id={idNamingConversion('City', 'customerProfile', 'DropDown')}
                                                            parentValue={customObject(cityDetails, cityId)}
                                                            onChange={(data) => changeCity(data.id)}
                                                            position={"top"}
                                                            customClasses={clsx(classes.margin20t)}
                                                        />
                                                        <AutoCompleteComponent
                                                            name={["Country"]}
                                                            heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                                            details={countryDetails}
                                                            id={idNamingConversion('Country', 'customerProfile', 'DropDown')}
                                                            parentValue={customObject(countryDetails, countryId)}
                                                            onChange={(data) => handleChangeCountry(data.id)}
                                                            position={"top"}
                                                            customClasses={clsx(classes.margin20t)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Contact Details</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    fullWidth
                                                    label='Contact Name'
                                                    error={errorContactForm && true}
                                                    helperText={errorContactForm}
                                                    value={contactName}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    id={idNamingConversion('Contact Name', 'customerProfile', 'TextField')}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setContactName(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='Alternate Name (Optional)'
                                                    error={erroremptyAlternateName && true}
                                                    helperText={erroremptyAlternateName}
                                                    fullWidth
                                                    value={tradingName}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    id={idNamingConversion('Alternate Name', 'customerProfile', 'TextField')}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setTradingName(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='Alternate Phone'
                                                    value={alternateMobile}
                                                    type='number'
                                                    // error={erroremptyAlternateNumber && true}
                                                    // helperText={erroremptyAlternateNumber}
                                                    fullWidth
                                                    variant={'standard'}
                                                    className={clsx(classes.margin20t)}
                                                    id={idNamingConversion('Alternate Phone', 'customerProfile', 'TextField')}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setAlternateMobile(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Payment Info</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Method of payment (MOP)"]}
                                                    heads={[{ 'key': 'method', 'name': 'Method' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={mopDetails}
                                                    onChangeText={(value) => {
                                                        if (value === '') {
                                                            setMopId('')
                                                        }
                                                    }}
                                                    id={idNamingConversion('Method of payment', 'customerProfile', 'DropDown')}

                                                    parentValue={customObject(mopDetails, mopId)}
                                                    onChange={(data) => setMopId(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                                    { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                                    details={currencyDetails}
                                                    id={idNamingConversion('Currency', 'customerProfile', 'DropDown')}
                                                    parentValue={customObject(currencyDetails, currencyId)}
                                                    onChange={(data) => setCurrencyId(data.id)}
                                                    parentError={errorCurrency}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Younote Info</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Younote ID</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.customerBusiness?.serialNo || '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>In-App Status</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.inAppStatus ? capitalizeFirstLetter(readDetails.inAppStatus) : 'No'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13) // Pass your override css here
                                                    }}
                                                    control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                        onChange={(e) => handleChangeTransaction(!inAppTransition, readDetails)} />
                                                    }
                                                    id={idNamingConversion('In-AppTransactions', 'customerProfile', 'Radio')}
                                                    label="In-AppTransactions"
                                                    checked={inAppTransition}
                                                    labelPlacement="top"
                                                    disabled={customerBusinessId ? inAppStatus === 'REQUEST SENT' ? true : false : true}
                                                    className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                />
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                    Other Taxes</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Cash Discount"]}
                                                    heads={[{ 'key': 'code', 'name': 'Code' }]}
                                                    details={cashDiscountDetails || []}
                                                    id={idNamingConversion('Cash Discount', 'customerProfile', 'DropDown')}
                                                    parentValue={customObject(cashDiscountDetails || [], cashDiscountId)}
                                                    onChange={(data) => setCashDiscountId(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Tax Code "]}
                                                    heads={[{ 'key': 'code', 'name': 'Code' }]}
                                                    details={taxCodedetails}
                                                    id={idNamingConversion('Tax Code', 'customerProfile', 'DropDown')}
                                                    parentValue={customObject(taxCodedetails, taxCodeId)}
                                                    onChange={(data) => setTaxCodeId(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                    }}
                                                    id={idNamingConversion('TCS', 'customerProfile', 'Radio')}
                                                    control={<Switch size='small'
                                                        className={clsx(classes.customSwitch)}
                                                        onChange={(e) => setTcs(!tcs)}
                                                        checked={tcs}
                                                    />}
                                                    label="TCS"
                                                    labelPlacement="top"
                                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                    }}
                                                    id={idNamingConversion('TDS', 'customerProfile', 'Radio')}
                                                    control={<Switch size='small'
                                                        className={clsx(classes.customSwitch)}
                                                        onChange={(e) => setTds(!tds)}
                                                        checked={tds}
                                                    />}
                                                    label="TDS"
                                                    labelPlacement="top"
                                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                                />
                                            </Col>
                                            {
                                                tcs && <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                    <AutoCompleteComponent
                                                        name={["TCS "]}
                                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                        details={(otherTaxesdetails || []).filter(el => el.taxType === 'TCS')}
                                                        id={idNamingConversion('TCS', 'customerProfile', 'DropDown')}
                                                        parentValue={customObject((otherTaxesdetails || []).filter(el => el.taxType === 'TCS'), tcsId)}
                                                        onChange={(data) => setTcsId(data.id)}
                                                        position={"top"}
                                                        customClasses={classes.margin20t}
                                                        parentError={errorTcs}
                                                    />
                                                </Col>
                                            }
                                        </Row>
                                    </Box>
                                }
                                {
                                    showDetails && (
                                        <div className={classes.textAlignCenter}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Sales Price Details'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                                <TabContext className={clsx(classes.tableRoot)} value={value}>
                                    <Box className={clsx(classes.tabDesign)}>
                                        <TabList onChange={handleChange}>
                                            <Tab className={classes.Bordertab_1} label="Sales Price" value={'sales-price'} />
                                            <Tab className={classes.Bordertab_2} label="Sales Discount" value={'sales-discount'} />
                                        </TabList>
                                    </Box>
                                    {
                                        readLoader === false ? readDetails && <>
                                            {
                                                value === 'sales-price' ? <SalesPrice topBarView={false}
                                                    ref={priceRef}
                                                    {...props}
                                                    customerId={decryptedId}
                                                    groupId={readDetails?.groupId}
                                                    title={value.replace("-", " ")}
                                                    apiUrl={apiUrl} heads={heads} /> : <SalesDiscount topBarView={false}
                                                        ref={priceRef}
                                                        {...props}
                                                        customerId={decryptedId}
                                                        groupId={readDetails?.groupId}
                                                        title={value.replace("-", " ")}
                                                        apiUrl={apiUrl} heads={heads} />
                                            }
                                        </>
                                            : <div className={classes.textAlignCenter}>
                                                <div className={classes.loadMoreCircle}></div>
                                            </div>
                                    }
                                </TabContext>
                            </>
                        }
                    />
                    {/* <CustomAccordion
                        title={'Customer Products'}
                        top={"116"}
                        topVisible={"250px"}
                        zIndex={5}
                        showDetails={showDetails}
                        index={2}
                        ref={childRef}
                        component={
                            <>
                            </>
                        }
                        lastContent={true}
                    /> */}
                </div>
            </div>
            <QuickLinks menus={menus} factBox={factBox} component={"All Customers"} onParentFunction={() => childRef?.current?.handleAdjustHeight()}></QuickLinks>
        </React.Fragment>
    )
}
export default CustomerEdit